export default (variable) => window._env && window._env[variable];
